import { markPasteRule } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import { find } from 'linkifyjs';
export const CustomLink = Link.extend({
    name: 'custom-link',
    addOptions() {
        var _a;
        return {
            ...(_a = this.parent) === null || _a === void 0 ? void 0 : _a.call(this),
            autolink: false,
            onPaste: undefined,
        };
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: text => {
                    var _a, _b;
                    const matched = find(text)
                        .filter(link => link.isLink)
                        .map(link => ({
                        text: link.value,
                        index: link.start,
                        data: link,
                    }));
                    if (matched.length > 0) {
                        (_b = (_a = this.options).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, matched, this.editor);
                    }
                    return matched;
                },
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return ({
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    });
                },
            }),
        ];
    },
    addCommands() {
        var _a;
        return {
            ...(_a = this.parent) === null || _a === void 0 ? void 0 : _a.call(this),
            insertLink: ({ href, target = '_blank', text }) => ({ commands }) => {
                return commands.insertContent(`<a href="${href}" target=${target}>${text || href}</a>`);
            },
        };
    },
});
//# sourceMappingURL=index.js.map